import React from 'react';
import Audio from '../Audio/AudioContainer';
import { trackOutboundLink } from '../../google-analytics';

const Footer = ({ changeView, view }) =>  {
  return (
    <div className="footer">
        <ul className="footer__nav">
            <li>
                <a target="_blank" href="https://www.valottery.com/termsandconditions.aspx" onClick={ e => trackOutboundLink(e, 'https://www.valottery.com/termsandconditions.aspx') }>Legal</a>
            </li>
            <li>
                <a target="_blank" href="https://www.valottery.com/" onClick={ e => trackOutboundLink(e, 'https://www.valottery.com/') }>Virginia Lottery</a>
            </li>
            <li>
                <a target="_blank" href="https://www.facebook.com/valottery/" onClick={ e => trackOutboundLink(e, 'https://www.facebook.com/valottery/')}>
                    <svg className="icon" viewBox="0 0 18 18">
                        <use xlinkHref="#icon-facebook"></use>
                    </svg>
                </a>
            </li>
            <li>
                <a target="_blank" href="https://twitter.com/VirginiaLottery" onClick={ e => trackOutboundLink(e, 'https://twitter.com/VirginiaLottery')}>
                    <svg className="icon" viewBox="0 0 18 18">
                        <use xlinkHref="#icon-twitter"></use>
                    </svg>
                </a>
            </li>
            <li>
              <Audio />
            </li>
        </ul>
    </div>
  );
}

export default Footer;



/** WEBPACK FOOTER **
 ** ./src/components/Footer/Footer.js
 **/